var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
function getAllValues(item, filterDisabled) {
  var _a;
  const values = [];
  if (filterDisabled && item.disabled)
    return values;
  if ((_a = item.children) != null && _a.length)
    for (const child of item.children)
      values.push(...getAllValues(child, filterDisabled));
  else item.value && values.push(item.value);
  return values;
}
__name(getAllValues, "getAllValues");
function getCheckboxStatus(values, modelValue) {
  if (!modelValue)
    return !1;
  let length = 0;
  for (const value of values)
    modelValue.includes(value) && length++;
  return length === 0 ? !1 : length === values.length ? !0 : "indeterminate";
}
__name(getCheckboxStatus, "getCheckboxStatus");
function getModelValueNotIncludesValues(values, modelValue) {
  return values.filter((value) => !modelValue.includes(value));
}
__name(getModelValueNotIncludesValues, "getModelValueNotIncludesValues");
function deleteModelValueIncludesValues(values, modelValue) {
  if (modelValue.value)
    for (const value of values.value) {
      const idx = modelValue.value.indexOf(value);
      idx >= 0 && modelValue.value.splice(idx, 1);
    }
}
__name(deleteModelValueIncludesValues, "deleteModelValueIncludesValues");
export {
  deleteModelValueIncludesValues,
  getAllValues,
  getCheckboxStatus,
  getModelValueNotIncludesValues
};
//# sourceMappingURL=utils.js.map
